<app-accessibility-toolbar *ngIf="portalLive == true"></app-accessibility-toolbar>

<div class="container-fluid">
    <div class="welcome row">

        <!-- LEFT: titlu + butoane -->
        <div class="welcome-left col-lg-6 d-flex flex-column justify-content-center align-items-start">
            <span class="welcome-title">Bine ați venit!</span>
            <span class="welcome-subtitle">De aici veți putea accesa toate serviciile publice digitale oferite
                cetățenilor Sectorului 4.</span>

            <button *ngIf="!isAuthenticated()" class="btn-auth" type="button" routerLink="/pages/login">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="8" r="4" />
                    <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
                </svg>
                AUTENTIFICAȚI-VĂ AICI
            </button>

            <span class="quick-label">Servicii rapide</span>

            <div class="quick-actions-grid">

                <!-- Programare -->
                <div class="action-card card-programare" (click)="navigateTo('public/programare-asistenta')">
                    <div class="icon-wrap">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0044CC" stroke-width="2">
                            <rect x="3" y="4" width="18" height="18" rx="2" />
                            <line x1="16" y1="2" x2="16" y2="6" />
                            <line x1="8" y1="2" x2="8" y2="6" />
                            <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                    </div>
                    <div class="card-text">
                        <span class="card-label">PROGRAMAȚI-VĂ</span>
                        <span class="card-sub">Biroul de asistență</span>
                    </div>
                </div>

                <!-- Taxa specială -->
                <div class="action-card card-taxa" *ngIf="taxAllowed == true"
                    (click)="navigateTo('taxa-speciala-dezvoltare-urbana')">
                    <div class="icon-wrap">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2233aa" stroke-width="2">
                            <path d="M3 3h18v4H3z" />
                            <path d="M3 10h18v11H3z" />
                            <line x1="7" y1="15" x2="17" y2="15" />
                        </svg>
                    </div>
                    <div class="card-text">
                        <span class="card-label">TAXA SPECIALĂ</span>
                        <span class="card-sub">Dezvoltare urbană</span>
                    </div>
                </div>

                <!-- Carburant -->
                <div class="action-card card-carburant" *ngIf="!userService.isUserPersoanaJuridica()"
                    (click)="navigateTo('carburant')">
                    <div class="icon-wrap">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF6600" stroke-width="2">
                            <path d="M3 22V8l7-6 7 6v14" />
                            <path d="M15 22v-6h-4v6" />
                            <path d="M18 10l3 3v7" />
                        </svg>
                    </div>
                    <div class="card-text">
                        <span class="card-label">AJUTOR CARBURANT</span>
                    </div>
                </div>

                <!-- Transport -->
                <div class="action-card card-transport" *ngIf="!userService.isUserPersoanaJuridica()"
                    (click)="navigateTo('transport')">
                    <div class="icon-wrap">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" stroke-width="2">
                            <rect x="3" y="6" width="18" height="13" rx="2" />
                            <path d="M7 19v2M17 19v2" />
                            <path d="M3 10h18" />
                            <circle cx="7.5" cy="15" r="1" />
                            <circle cx="16.5" cy="15" r="1" />
                        </svg>
                    </div>
                    <div class="card-text">
                        <span class="card-label">AJUTOR TRANSPORT PUBLIC</span>
                        <span class="card-sub">STB · Metrou · Mixt</span>
                    </div>
                </div>

                <!-- Depune cerere -->
                <div class="action-card card-cerere" (click)="scrollTo('depunere')">
                    <div class="icon-wrap">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <polyline points="14 2 14 8 20 8" />
                            <line x1="8" y1="13" x2="16" y2="13" />
                            <line x1="8" y1="17" x2="16" y2="17" />
                        </svg>
                    </div>
                    <div class="card-text">
                        <span class="card-label">DEPUNE O CERERE</span>
                    </div>
                </div>

                <!-- Plăți online -->
                <div class="action-card card-plati" (click)="scrollTo('plati-online')">
                    <div class="icon-wrap">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#c17c00" stroke-width="2">
                            <rect x="2" y="5" width="20" height="14" rx="2" />
                            <line x1="2" y1="10" x2="22" y2="10" />
                        </svg>
                    </div>
                    <div class="card-text">
                        <span class="card-label">PLĂȚI ONLINE</span>
                    </div>
                </div>

            </div>
        </div>

        <!-- RIGHT: imagine/video -->
        <div class="welcome-right col-lg-6">
            <div class="welcome-side-box">
                <div class="welcome-small-square">
                    <img src="assets/images/hp-small-square-ps4.jpg" class="img-responsive img-fluid" />
                </div>
                <div class="welcome-image">
                    <video class="elementor-background-video-hosted elementor-html5-video" autoplay [muted]="'muted'"
                        playsinline loop
                        src="https://ctapi.mobilitateurbana4.ro/342994181_680519600499896_3395361040270132430_n.mp4">
                    </video>
                </div>
            </div>
        </div>

    </div>
    <div class="section1">
        <div
            class="section1-content d-flex flex-lg-row flex-column justify-content-lg-between justify-content-center align-items-center">
            <span>Programare pentru Asistență - Biroul de Asistență</span>
            <button class="mt-lg-0 mt-3 d-flex justify-content-center align-items-center" type="button"
                (click)="navigateTo('public/programare-asistenta')">PROGRAMAȚI-VĂ!</button>
        </div>
    </div>

    <div class="section1" *ngIf="taxAllowed == true">
        <div
            class="section1-content d-flex flex-lg-row flex-column justify-content-lg-between justify-content-center align-items-center">
            <span>Taxa specială pentru <span class="white-text">dezvoltare urbană</span></span>
            <button class="mt-lg-0 mt-3 d-flex justify-content-center align-items-center" type="button"
                (click)="navigateTo('taxa-speciala-dezvoltare-urbana')">INFORMAȚII</button>
        </div>
    </div>

    <div class="section1" *ngIf="!userService.isUserPersoanaJuridica()">
        <div
            class="section1-content section1-content--carburant d-flex flex-lg-row flex-column justify-content-lg-between justify-content-center align-items-center">
            <span>Ajutor de <span class="white-text">Carburant</span></span>
            <button class="mt-lg-0 mt-3 d-flex justify-content-center align-items-center" type="button"
                (click)="navigateTo('carburant')">INFORMAȚII</button>
        </div>
    </div>

    <div class="section1" *ngIf="!userService.isUserPersoanaJuridica()">
        <div
            class="section1-content section1-content--transport d-flex flex-lg-row flex-column justify-content-lg-between justify-content-center align-items-center">
            <span>Ajutor pentru <span class="white-text">Transport Public</span>
                <span class="banner-subtitle">STB · Metrou · Mixt</span>
            </span>
            <button class="mt-lg-0 mt-3 d-flex justify-content-center align-items-center" type="button"
                (click)="navigateTo('transport')">INFORMAȚII</button>
        </div>
    </div>

    <div class="section2 container-fluid" id="depunere">
        <div class="section2-content d-flex gap-3 flex-column flex-xl-row">
            <div class="row">
                <div class="section2-content-card d-flex align-items-start col-lg-3 me-1 mb-2">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <span>Depune o cerere pentru</span>
                        <img src="assets/icons/arrow-big.svg" />
                    </div>
                </div>
            </div>

            <div class="d-flex flex-wrap w-100">
                <div (click)="navigateTo(loggedLinks.solicitariUrbanismPlatform)"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/Stema-Bucuresti_line.svg" style="height: 80px;" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Direcția Generală de Urbanism și Amenajarea Teritoriului Sector 4</span>
                        <!-- <span class="tag">#TaxeȘiImpozite</span> -->
                    </div>
                </div>
                <div (click)="navigateTo(publicLinks.solicitariDgitl)"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/dgitl4.svg" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Direcția Generală de Impozite și Taxe Locale</span>
                        <!-- <span class="tag">#TaxeȘiImpozite</span> -->
                    </div>
                </div>
                <div (click)="navigateToNewTab('https://www.mobilitateurbana4.ro/registratura-online/')"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/mobilitate-urbana.svg" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Direcția Mobilitate Urbană</span>
                        <!-- <span class="tag">#MobilitateUrbană</span> -->
                    </div>
                </div>
                <div (click)="navigateTo(publicLinks.solicitariAutorizariComerciale)"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/Stema-Bucuresti_line.svg" style="height: 80px;" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Serviciul Autorizări Comerciale</span>
                        <!-- <span class="tag">#AutorizăriComerciale</span> -->
                    </div>
                </div>

                <div (click)="navigateTo(publicLinks.programariOnline)"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/dgep.svg" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Direcția Generală de Evidență a Persoanelor</span>
                        <!-- <span class="tag">#AutorizăriComerciale</span> -->
                    </div>
                </div>

                <div *ngIf="!userService.isUserPersoanaJuridica()"
                    (click)="navigateTo(loggedLinks.solicitariAsistentaSociala)"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/dgaspc4.svg" style="height: 80px;" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Direcția Generală de Asistență Socială și Protecția Copilului</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="section2 container-fluid">
        <div class="section2-content d-flex gap-3 flex-column flex-xl-row">
            <div class="row">
                <div class="section2-content-card d-flex align-items-start col-lg-3 me-1 mb-2">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <span>Declarații</span>
                        <img src="assets/icons/arrow-big.svg" />
                    </div>
                </div>
            </div>

            <div class="d-flex flex-wrap w-100">
                <div (click)="navigateTo(publicLinks.declaratii + 'dgaspc')"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/dgaspc4.svg" style="height: 80px;" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Direcția Generală de Asistență Socială și Protecția Copilului</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section2 container-fluid">
        <div class="section2-content d-flex gap-3 flex-column flex-xl-row">
            <div class="row">
                <div class="section2-content-card d-flex align-items-start col-lg-3 me-1 mb-2">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <span>Carieră</span>
                        <img src="assets/icons/arrow-big.svg" />
                    </div>
                </div>
            </div>

            <div class="d-flex flex-wrap w-100">
                <div (click)="navigateTo(publicLinks.cariera + 'dgaspc')"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/dgaspc4.svg" style="height: 80px;" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Direcția Generală de Asistență Socială și Protecția Copilului</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section2 container-fluid">
        <div class="section2-content d-flex gap-3 flex-column flex-xl-row">
            <div class="row">
                <div class="section2-content-card d-flex align-items-start col-lg-3 me-1 mb-2">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <span>Achiziții Publice</span>
                        <img src="assets/icons/arrow-big.svg" />
                    </div>
                </div>
            </div>

            <div class="d-flex flex-wrap w-100">
                <div (click)="navigateTo(publicLinks.achizitii + 'dgaspc')"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/dgaspc4.svg" style="height: 80px;" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Direcția Generală de Asistență Socială și Protecția Copilului</span>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <!-- <div class="section2 container-fluid">
        <div class="section2-content row" style="background: transparent;">
            <div (click)="navigateTo('/noutati')" class="section3-content-card d-flex flex-column justify-content-between align-items-start col-lg-3 me-1 mb-2">
                <div class="d-flex align-items-center">
                    <span>Ultimele noutăți</span>
                    <img src="assets/icons/homepage-right-arrow.svg" />
                </div>
                <button class="d-flex justify-content-center align-items-center align-self-stretch" type="button">VEZI TOATE
                </button>
            </div>

            <ng-container *ngIf="!isLoading">
                <ng-container *ngFor="let row of articleList">
                    <div class="section3-content-cards d-flex flex-column justify-content-end align-items-start col-lg-3 ms-1 me-1 mb-2" (click)="navigateToArticle(row.id)">
                        <div class="image" [ngStyle]="{'background-image': 'url(' + row.image_url + ')'}"></div>
                        <div class="section2-content-cards-text d-flex flex-column justify-content-start align-items-start">
                            <span class="title">{{ (row.title.length > 33) ? (row.title | slice: 0:32) + '...' : (row.title) }}</span>
                            <span class="tag">{{ formatDate(row.last_updated) }}</span>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="isLoading">
                <div class="spinner d-flex flex-column justify-content-center align-items-center col-lg-3">
                    <mat-spinner></mat-spinner>
                    <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                </div>
            </ng-container>
        </div>
    </div> -->

    <div class="section2 container-fluid" id="plati-online">
        <div class="section2-content d-flex gap-3 flex-column flex-xl-row"
            style="background: linear-gradient(0deg, #FFD180 0%, #FFD180 100%), #FE7800;">
            <div class="row">
                <div class="section2-content-card d-flex align-items-start me-1 mb-2">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <span>Plăți Online</span>
                        <img src="assets/icons/arrow-big.svg" />
                    </div>
                </div>
            </div>

            <div class="d-flex flex-wrap w-100">
                <div class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2"
                    (click)="navigateTo(loggedLinks.platiOnline)">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/taxe-nedebitate.svg" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Taxe și Impozite</span>
                        <!-- <span class="tag">#ImpoziteȘiTaxe</span> -->
                    </div>
                </div>
                <div (click)="navigateTo(publicLinks.programariOnline+'/plati-online')"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/evidenta-populatiei.svg" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Evidența Populației</span>
                        <!-- <span class="tag">#EvidențaPopulației</span> -->
                    </div>
                </div>
                <div (click)="navigateToNewTab('https://www.mobilitateurbana4.ro/plati/')"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/parcari.svg" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Parcări</span>
                        <!-- <span class="tag">#MobilitateUrbană</span> -->
                    </div>
                </div>
                <div class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2"
                    (click)="navigateTo(loggedLinks.platiAlteTaxeAmenzi)">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/taxe-nedebitate.svg" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Alte Taxe și Amenzi</span>
                        <!-- <span class="tag">#ImpoziteȘiTaxe</span> -->
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section2 container-fluid">
        <div class="section2-content d-flex gap-3 flex-column flex-xl-row"
            style="background: linear-gradient(0deg, rgba(105, 240, 174, 0.16) 0%, rgba(105, 240, 174, 0.16) 100%), rgba(105, 240, 174, 0.70);">
            <div class="row">
                <div class="section2-content-card d-flex align-items-start me-1 mb-2">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <span>Link-uri rapide</span>
                        <img src="assets/icons/arrow-big.svg" />
                    </div>
                </div>
            </div>

            <div class="d-flex flex-wrap w-100">
                <div (click)="navigateToNewTab('https://ps4.ro/')"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/Stema-Bucuresti_line.svg" style="height: 80px;" />
                        <!-- <img src="assets/icons/ps4.svg" style="height: 80px;" /> -->
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Site principal - Primăria Sectorului 4</span>
                        <!-- <span class="tag">#ConsiliulLocal4</span> -->
                    </div>
                </div>
                <div (click)="navigateToNewTab('https://ps4.ro/monitorul-oficial-local/hotararile-autoritatii-deliberative/hotarari/')"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/hotarari-consiliu.svg" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Hotărâri consiliu</span>
                        <!-- <span class="tag">#ConsiliulLocal4</span> -->
                    </div>
                </div>
                <div (click)="navigateToNewTab('https://ps4.ro/monitorul-oficial-local/dispozitiile-autoritatii-executive/dispozitii/')"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/dispozitii.svg" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Dispoziții</span>
                        <!-- <span class="tag">#PrimăriaSectorului4</span> -->
                    </div>
                </div>
                <div (click)="navigateToNewTab('https://taxeimpozite4.ro')"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/dgitl4.svg" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Taxe și Impozite</span>
                        <!-- <span class="tag">#TaxeȘiImpozite</span> -->
                    </div>
                </div>
                <div (click)="navigateToNewTab('https://mobilitateurbana.ps4.ro')"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/mobilitate-urbana.svg" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Parcări</span>
                        <!-- <span class="tag">#MobilitateUrbană</span> -->
                    </div>
                </div>
                <div (click)="navigateToNewTab('https://dgaspc.ps4.ro')"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/dgaspc4.svg" style="height: 80px;" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Asistență Socială și Protecția Copilului</span>
                        <!-- <span class="tag">#DGASPCS4</span> -->
                    </div>
                </div>
                <div (click)="navigateToNewTab('https://deps4.ro')"
                    class="section2-content-cards d-flex flex-column justify-content-between ms-1 me-1 mb-2">
                    <div
                        class="section2-content-cards-header d-flex flex-row justify-content-between align-items-start">
                        <img src="assets/icons/dgep.svg" />
                        <img class="arrow-right" src="assets/icons/arrow-right.svg" />
                    </div>
                    <div
                        class="section2-content-cards-text d-flex flex-column justify-content-end align-items-start align-self-stretch">
                        <span class="title">Evidența Persoanelor</span>
                        <!-- <span class="tag">#EvidențaPersoanelor</span> -->
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="footer">
        <app-footer></app-footer>
    </div>
</div>